

import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import app from './config';


const messaging = getMessaging(app);

export const requestFCMToken = async () => {
    
  try {
    if (Notification.permission !== 'granted') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.warn('🚫 Notification permission not granted.');
          return null;
        }
      }
    const currentToken = await getToken(messaging, {
      vapidKey: 'BIrcj_KQBJAa4u8JnSrP4jhj8sHC9s_Qgfpab3BD0jRKTbOeIHcD2K779Q489oRKDgApKgkjzHVvHgmY7yRQ9Ww', // Get this from Firebase Console → Cloud Messaging tab
      serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sw.js'),
    });

    if (currentToken) {
      console.log('FCM Token:', currentToken);
      return currentToken;
    } else {
      console.warn('No registration token available. Request permission to generate one.');
      return null;
    }
  } catch (err) {
    console.error('An error occurred while retrieving token. ', err);
    return null;
  }
};

export const listenForMessages = (callback) => {
    onMessage(messaging, (payload) => {
      console.log('[Foreground] Message received:', payload);
      
      if (callback) callback(payload);
    });
  };